import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

// Components
import { Wrapper, Inner, Left, Right, BookingTrigger } from './files';

// Context
import ContextConsumer from '../../contextProvider';

const Features = ({ contentSection, features, roomTypeId, modal }) => (
  <ContextConsumer>
    {({ location, toggleRoomBooking }) => (
      <Wrapper>
        <Inner>
          <Left>
            <h3>{contentSection.title}</h3>
            <div
              dangerouslySetInnerHTML={{
                __html: contentSection.text.childMarkdownRemark.html
              }}
            />
            {!modal && (
              <BookingTrigger>
                <button value={roomTypeId} onClick={toggleRoomBooking}>
                  {location.pathname.includes('rooms') && <>Book this room</>}
                  {location.pathname.includes('apartment') && (
                    <>Book this apartment</>
                  )}
                </button>
                <Link className="button" to="/enquiry/">
                  Contact Us
                </Link>
              </BookingTrigger>
            )}
          </Left>
          <Right>
            <ul>
              {features.map((i) => (
                <li key={i.id}>
                  <Img fluid={i.icon.fluid} alt={i.title} />
                  <h4>{i.title}</h4>
                </li>
              ))}
            </ul>
          </Right>
        </Inner>
      </Wrapper>
    )}
  </ContextConsumer>
);

export default Features;
